export * from './OptimizationDialog';

export enum OptimizationDialogOpenValue {
    Closed,
    Open,
    UnassignedOpen
}

export enum OptimizationDialogConsiderOption {
    Route,
    Area,
    None
}
